<template>
  <div id="nim-project-editor" class="Home nim-student-surface nim-project-editor" :data-theme="studentTheme">
    <button class="nim-theme-toggle" type="button" @click="toggleStudentTheme" :aria-label="studentTheme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'" :title="studentTheme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'">{{ studentTheme === 'dark' ? '☀' : '☾' }}</button>
    <!-- 头部 -->
    <div class="head">
      <button type="button" class="btn nim-back-projects" @click="$router.push('/studentProjects').catch(() => {})">← Back to Projects</button>

      <span
        v-if="lookType === 'student' && projectTeamRole === '领队' && application_id && aiCritiqueVisible"
        class="btn"
        :aria-disabled="aiCritiqueChecking || aiCritiqueSubmitting ? 'true' : 'false'"
        @click="requestAICritique"
      >{{ aiCritiqueSubmitting ? 'Submitting...' : (aiCritiqueChecking ? 'Checking...' : (aiCritiqueNotificationPending ? 'Retry Notification' : 'AI Critique')) }}</span>

      <span class="btn" @click="openEditHistory()">Edit History</span>
      <span class="btn" @click="getPdf()">Aggregate</span>
      <el-dropdown>
        <i class="el-icon-setting" style="margin-right: 40px"></i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item ><div @click="logout()">Log Out</div></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- <div class="templateHead">
      <h3>{{template_name}}
          <el-button v-if="project_id==='6087cb92a4640b8b5a8b4588' ||  project_id==='6279fa81a4640b5b678b4597'" type="primary" @click="sendEmail" style="margin-left:30px">我已完成简历填写，确认提交</el-button>
      </h3>
      <p>{{template_description}}</p>
    </div> -->
    <el-container class="center">
      <el-aside class="aside" width="20%">
        <!-- <el-menu :default-openeds="['1', '3']" @select="onselect" @open="onopen" @close="onclose">
          <el-submenu index="1" title="试试看" >
              <template slot="title"><i class="el-icon-message"></i>导航一</template>
              <el-menu-item index="1-1">选项1</el-menu-item>
              <el-menu-item index="1-2">选项2</el-menu-item>

          </el-submenu>
          <el-submenu index="2">
            <template slot="title"><i class="el-icon-menu"></i>导航二</template>
            <el-menu-item-group>
              <template slot="title">分组一</template>
              <el-menu-item index="2-1">选项1</el-menu-item>
              <el-menu-item index="2-2">选项2</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group title="分组2">
              <el-menu-item index="2-3">选项3</el-menu-item>
            </el-menu-item-group>
            <el-submenu index="2-4">
              <template slot="title">选项4</template>
              <el-menu-item index="2-4-1">选项4-1</el-menu-item>
            </el-submenu>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title"><i class="el-icon-setting"></i>导航三</template>
            <el-menu-item-group>
              <template slot="title">分组一</template>
              <el-menu-item index="3-1">选项1</el-menu-item>
              <el-menu-item index="3-2">选项2</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group title="分组2">
              <el-menu-item index="3-3">选项3</el-menu-item>
            </el-menu-item-group>
            <el-submenu index="3-4">
              <template slot="title">选项4</template>
              <el-menu-item index="3-4-1">选项4-1</el-menu-item>
            </el-submenu>
          </el-submenu>
        </el-menu> -->
        <el-collapse v-model="activeC">
          <el-collapse-item :title="template_name" name="default">
            <el-tree empty-text="No Data" :data="menuItems" :props="defaultProps" @node-click="handleNodeClick" :render-content="renderContent"></el-tree>
          </el-collapse-item>
        </el-collapse>
      </el-aside>

      <el-container style="margin-left:50px;background: #fff;">

        <el-main class="centerMain">
          <!-- <el-table :data="tableData">
            <el-table-column prop="date" label="日期" width="140">
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="120">
            </el-table-column>
            <el-table-column prop="address" label="地址">
            </el-table-column>
          </el-table> -->
          <div class="toptitle">
            {{content.block_name || 'Please select a section on the left.'}}
            <span class="title-description" v-if="content.content_type === 'VIDEO'"> (This section has {{content_quiz.length}} quiz questions)</span>

            <span class="tip" v-if="content.block_require=='yes'">Required</span>
          </div>

          <div v-if="content.block_name" class="content_instruction">{{content.block_description || ''}}</div>
          <div v-if="content.block_name && checklist.length" class="check-box">
            <h3 v-if="checklist.length" style="margin-bottom:8px">Rating items for this part:</h3>
            <p v-if="checklist.length" style="margin-bottom:20px;font-weight:normal">Please use the following rating items to self-check and revise your work. Your final score will be determined by each criterion.</p>
            <div v-for="(item, index) in checklist" :key="item.client_id || (item._id && item._id.$id) || index" style="margin-top:10px">
              <el-checkbox :label="index" :key="item.check_content" v-model="item.check_status" @change="handleCheckedCitiesChange(item)">
                <div class="check-box-item">
                  <span class="rating-dimension" v-if="item.dimension || item.check_type" style="background:rgba(0,114,255,0.1600);padding:2px 10px;margin-right:10px;border-radius:10px;color:#0E4890">{{item.dimension || item.check_type}}</span>{{item.check_content}}
                </div>
              </el-checkbox>
            </div>
          </div>

          <div v-if="content.block_type === 'HTML'" style="height:calc(100% - 60px)">
            <div v-if="content.html_text" v-html="content.html_text"></div>
            <iframe v-if="!content.html_text && content.pdf_url" :src="resolveMediaUrl(content.pdf_url)" width="100%" height="100%">

            This browser does not support PDFs. Please download the PDF to view it: <a :href="resolveMediaUrl(content.pdf_url)">Download PDF</a>

            </iframe>

            <div v-if="!content.html_text && !content.pdf_url" style="margin-top:20px">Coming soon.</div>
          </div>
          <div v-if="content.block_type === 'VIDEO'">
            <div>
              <video :src="resolveMediaUrl(content.video_url)" id="videoPlay" controls="controls" class="video" oncontextmenu="return false;" v-show="!isBeginQuiz" @timeupdate="timeupdate" @ended="videoEnd">Your browser does not support video play.</video>
              <Quiz :studentId="studentId" :quizs="quizs" :onDone="onQuizDone" />
            </div>
          </div>
          <el-dialog
            title="Video Play"
            custom-class="no-header-dialog"
            :visible.sync="dialogVisible"
            width="1165px"
            :height="300"
            center
            :show-close="false"
            destroy-on-close>
            <div class="video_container">
              <video class="video" :src="address" controls="controls" width="100%" height="100%"></video>
            </div>
            <!-- <span slot="footer" class="dialog-footer">
              <el-button @click="closeVideo">Cancel</el-button>
              <el-button type="primary" @click="closeVideo">Confirm</el-button>
            </span> -->
          </el-dialog>

          <el-collapse v-model="activeNames" v-show="appendix">
            <el-collapse-item title="Reference Materials" name="appendix">
              <div class="attach_arr">
                <div class="appendix" >
                  <div style="text-align: center;margin-right:10px;width:30%" v-for="item in attach_arr" :key="item._id.$id">
                    <div style="text-align:center;margin-top:30px" v-if="item.attach_format !== 'video'">
                      <img class="attach-img" :src="resolveAttachThumbUrl(item.attach_avatar_url)" alt="">
                    </div>
                    <a class="attach" v-if="item.attach_format !== 'video'" target="_blank" :href="resolveMediaUrl(item.attach_address)" :download="item.attach_name">{{ item.attach_name }}</a>
                    
                    <div style="text-align:center;margin-top:30px" v-if="item.attach_format === 'video'" @click="playVideo(resolveMediaUrl(item.attach_address))">
                      <img class="attach-img" :src="resolveAttachThumbUrl(item.attach_avatar_url)" alt="">
                      <a>{{ item.attach_name }}</a>
                    </div>
                    <!-- <div v-if="item.attach_format === 'video'" @click="playVideo(item.attach_address)"> -->
                     <!-- <img class="attach-img" :src="item.attach_avatar_ur || 'https://i1.wp.com/www.questionpro.com/blog/wp-content/uploads/2015/03/primary-test-it.png?w=293&ssl=1'" alt=""> -->
                      <!-- <a>{{ item.attach_name }}</a>
                    </div> -->
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <el-dialog
            title="Video Play"
            :visible.sync="videoDialogVisible"
            width="60%"
            center
            @close="closeVideo">
            <div class="video_container">
              <video class="video" :src="videoAddress" controls="true" controlslist="nodownload" width="80%" height="80%"></video>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="closeDialog">Cancel</el-button>
              <el-button type="primary" @click="closeDialog">Confirm</el-button>
            </span>
          </el-dialog>
          <div class="progress" v-if="proVisible">
            <el-progress :percentage='process'></el-progress>
          </div>
          
          <div style="margin-top:20px">
            <el-select v-model="update_block_content[0]" placeholder="Please select" v-if="content.block_format=='select'">
              <el-option
                v-for="item in selectOptions "
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>

          </div>

          <!-- team_credits: Member + Avatar + Contribution (repeatable) -->
          <div class="teamCreditsWrap" v-if="content.block_format==='team_credits'">
            <span style="margin-bottom:10px;" v-if="lookType != 'student'">Student Answers:</span>
            <div
              v-for="(row, index) in update_block_content"
              :key="'tc-' + index"
              class="teamCreditBlock"
            >
              <div class="teamCreditBlockHeader">
                <span class="teamCreditBlockTitle">Member {{ index + 1 }}</span>
                <span
                  class="removeInput"
                  v-if="lookType == 'student' && update_block_content.length > 1"
                  @click="removeTeamCreditMember(index)"
                >Remove member</span>
              </div>

              <div class="teamCreditMemberRoleRow">
                <div class="teamCreditField teamCreditFieldHalf">
                  <label class="teamCreditLabel">Member</label>
                  <el-select
                    v-model="row.member_id"
                    filterable
                    clearable
                    placeholder="Select a team member"
                    style="width:100%"
                    :disabled="lookType !== 'student' && lookType !== 'admin'"
                    @change="onTeamCreditMemberChange(index, $event)"
                  >
                    <el-option
                      v-for="opt in teamCreditMemberOptions"
                      :key="opt.id"
                      :label="opt.name"
                      :value="opt.id"
                      :disabled="isTeamCreditMemberTaken(opt.id, index)"
                    />
                  </el-select>
                </div>
                <div class="teamCreditField teamCreditFieldHalf">
                  <label class="teamCreditLabel">Role</label>
                  <el-input
                    v-model="row.role"
                    placeholder="e.g. Team Leader, Research Lead"
                    :disabled="lookType !== 'student' && lookType !== 'admin'"
                  />
                </div>
              </div>

              <div class="teamCreditField">
                <label class="teamCreditLabel">Avatar</label>
                <div class="teamCreditAvatarRow">
                  <div class="teamCreditAvatarPreview">
                    <img
                      v-if="teamCreditAvatarPreview(row, index)"
                      :src="teamCreditAvatarPreview(row, index)"
                      :key="teamCreditAvatarPreview(row, index)"
                      alt="Avatar preview"
                      @error="onTeamCreditAvatarPreviewError(index)"
                    >
                    <span v-else class="teamCreditAvatarEmpty">Square preview</span>
                  </div>
                  <div class="teamCreditAvatarActions" v-if="lookType == 'student' || lookType == 'admin'">
                    <label class="teamCreditAvatarUploadBtn">
                      {{ avatarUploadingIndex === index ? 'Uploading...' : (teamCreditAvatarPreview(row, index) ? 'Change avatar' : 'Upload avatar') }}
                      <input
                        type="file"
                        accept="image/*"
                        :disabled="avatarUploadingIndex === index"
                        @change="onTeamCreditAvatarPick($event, index)"
                      >
                    </label>
                    <span
                      v-if="teamCreditAvatarPreview(row, index)"
                      class="teamCreditAvatarClear"
                      @click="clearTeamCreditAvatar(index)"
                    >Remove</span>
                    <p class="teamCreditAvatarHint">Square crop · JPG/PNG · max 5 MB · used on Portfolio page</p>
                  </div>
                </div>
              </div>

              <div class="teamCreditField">
                <label class="teamCreditLabel">Contribution</label>
                <el-input
                  type="textarea"
                  :rows="5"
                  v-model="row.contribution"
                  placeholder="Describe this member's contribution"
                  :disabled="lookType !== 'student' && lookType !== 'admin'"
                />
              </div>
            </div>

            <span
              class="addInput1"
              v-if="lookType == 'student' || lookType == 'admin'"
              @click="addTeamCreditMember"
            >Add member</span>

            <div style="margin-top:20px">
              <span
                class="submitBtn"
                v-if="lookType == 'student' || lookType == 'admin'"
                :loading="s_a"
                @click="submitBlock"
              >Submit</span>
              <span
                v-if="latest_save_time !='No Records'"
                style="margin-left:10px;color: #999;font-size: 14px;"
              >Last Updated By {{ latest_save_name + ' on ' + latest_save_time }}</span>
            </div>
          </div>

          <div>
            <div style="margin-top:20px"  v-if="content.block_format==='input'">
              <div v-for="(item, index) in update_block_content" :key="index" >
                  <el-input style="margin-top:10px;" type="text" v-model="update_block_content[index]" ></el-input>
                  <div>
                    <el-select @change="updateCheck" v-if="content.block_review==='yes' && update_check_content && lookType!=='student'" v-model="update_check_content[index]">
                        <el-option value="Pending"></el-option>
                        <el-option value="Verified"></el-option>
                    </el-select>
                    <el-tag style="margin-left:20px" dark :type="update_check_content[index]==='已验证'?'success':'primary'" v-if="content.block_review==='yes' && update_check_content && lookType==='student'">{{update_check_content[index]}}</el-tag>
                  </div>
              </div>
              <span class="submitBtn" v-if="lookType == 'student' || lookType == 'admin' " :loading="s_a" @click="submitBlock">Submit</span>
            </div>
            <div style="margin-top:20px"  v-if="content.block_format==='textarea' || content.block_format==='pdf' || content.block_format==='video' || content.block_format==='archive' || content.block_format==='select'">
                <span style="margin-bottom:10px;"  v-if="lookType != 'student' ">Student Answers: </span>

                <template v-if="content.block_format === 'textarea'">
                <div v-for="(item, index) in update_block_content"  :key="index" >
                    <!-- <el-input style="margin-top:10px;" type="textarea" v-model="update_block_content[index]"></el-input> -->

                    <quill-editor class="editor2" ref="myTextEditor" v-model="update_block_content[index]"
                        :options="editorOption">
                    </quill-editor>

                    <div style="margin-top:20px">
                        <span class="removeInput" @click="removeInput(index)" v-if="lookType == 'student'">Remove the Textbox</span>
                        <el-select style="margin-left:10px" @change="updateCheck" v-if="content.block_review==='yes' && update_check_content && lookType!=='student'" v-model="update_check_content[index]">
                            <el-option value="Pending"></el-option>
                            <el-option value="Verified"></el-option>
                        </el-select>
                        <el-tag style="margin-left:20px" dark :type="update_check_content[index]==='已验证'?'success':'primary'" v-if="content.block_review==='yes' && update_check_content && lookType==='student'">{{update_check_content[index]}}</el-tag>
                    </div>
                </div>
              <span class="addInput1" v-if="lookType == 'student'&&content.multi_allowed === 'yes'" @click="addTextarea">Add a Textbox</span>
              </template>


              
              <div style="display: none;"></div>
              <!-- <input class="file" name="file" type="file"  accept="*" @change="getFile" v-if="lookType == 'student'" /><br/> -->
              <div style="position: relative;" v-if="content.block_format!='select'">

                <input
                  class="myFileUpload"
                  name="file"
                  type="file"
                  :accept="blockUploadConfig.accept"
                  :aria-label="blockUploadConfig.ariaLabel"
                  :disabled="upLoading"
                  @change="getBlockFile"
                />

                <span class="addInput2">
                  {{ upLoading ? 'Uploading...' : blockUploadConfig.label }}
                </span>
                <span class="blockUploadHint">
                  {{ blockUploadConfig.hint }}
                </span>
                
                <!-- <span class="submitBtn1" style="padding:8px 20px" @click="centerDialogVisible = true" :loading="upLoading">
                <i class="el-icon-plus"></i>
                Add an Attachment</span> -->
              </div>

              <el-collapse style="margin-top: 10px;" v-model="activeNames" v-show="content_attach.length !== 0">
                <el-collapse-item title="Attachments" name="1" v-show="content_attach.length !== 0">

                  <ul v-for="(item,index) in content_attach" :key="item._id.$id" class="attachItem">
                    <div>
                      <span class="attachType">{{item.attach_type}}:</span>
                      <el-popover
                        placement="top-start"
                        width="200"
                        trigger="hover"
                        :disabled="!item.attach_key"
                        :content="item.attach_key">
                        <a class="attach" target="_blank" :href="resolveMediaUrl(item.attach_address)" :download="item.attach_name" v-if="
                        !item.edit" slot="reference">{{item.attach_name }}  </a>
                      </el-popover>
                      <input type="text" v-model="item.attach_name " v-if="item.edit" />
                    </div>
                    <div>
                      <span class="deleteAttach" @click="deleteAttach(index)">Delete</span>
                      <span class="deleteAttach" @click="editAttach(index)" v-if="!item.edit">Edit</span>
                      <span class="deleteAttach" @click="confirmAttach(index)" v-if="item.edit">Confirm</span>
                    </div>
                  </ul>

                  <!-- <div>在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。</div> -->
                </el-collapse-item>

              </el-collapse>

              <el-pagination
                background
                layout="prev, pager, next"
                :total="past_content_array.length+1"
                :page-size="1"
                style="margin-top:10px"
                v-if="lookType != 'student'"
                @current-change="changePage"
                >
              </el-pagination>
              <el-dialog
                title="Upload Settings"
                :visible.sync="centerDialogVisible"
                width="720px"
                center>
                <div style="padding:0 50px 0 50px">
                <div class="select">
                  <div>File Type:</div>
                  <el-select v-model="selectType" placeholder="File Type" style="width:100%;margin-top:10px" size="medium">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div>
                  <div>Attachment Name：</div>
                  <el-input v-model="videoName" placeholder="Please input the name of your attachment" size="medium" style="margin-top:10px"></el-input>
                  <p v-if="selectType == 'file' || selectType == 'gongzhonghao' || selectType == 'website' " style="margin-top:10px">URL Link to Your Attachment：</p>
                  <el-input v-model="videoPath" placeholder="Please provide a url link to your attachment" v-if=" selectType == 'file' || selectType == 'gongzhonghao' || selectType == 'website'" style="margin-top:10px"></el-input>
                </div>

                <div v-if=" selectType == 'pdf' || selectType == 'image'">

                  <input class="hidden" name="file" type="file"  accept="*" @change="getFile" v-if=" selectType == 'pdf' || selectType == 'image'" /><br/>

                  <el-button type="primary" size="medium">
                    Upload Files
                  </el-button>

                  <span>{{ file?file.name : '' }}</span>
                </div>

                <div v-if=" selectType == 'video'">
                  <input class="hidden" name="file" type="file"  accept="*" @change="getVideoFile" v-if=" selectType == 'video'" /><br/>

                  <el-button type="primary" size="medium">
                    Upload Files
                  </el-button>

                  <span>{{ file?file.name : '' }}</span>
                </div>
                <!-- <input class="file" name="file" type="file"  accept="*" @change="getFile" v-if=" selectType == 'pdf' || selectType == 'image'" /><br/> -->
                <!-- <input class="file" name="file" type="file"  accept="*" @change="getVideoFile" v-if=" selectType == 'video'" /><br/> -->

                <div class="intro">
                  Attachment notes:
                  <el-input
                    type="textarea"
                    :rows="5"
                    placeholder="Please input notes for your attachment"
                    style="margin-top:10px;width: 100%;"
                    v-model="intro">
                  </el-input>
                  </div>
                  <span slot="footer" class="dialog-footer">
                    <span v-if=" selectType == 'video'" style="font-size:12px;color:#ccc;margin-right:20px">The file size of your attachment cannot exceed 1 GB</span>
                    <span v-if=" selectType == 'pdf' || selectType == 'image'" style="font-size:12px;color:#ccc;margin-right:20px">The file size of your attachment cannot exceed 5 MB</span>
                    <div class="diaFoot">
                      <span @click="centerDialogVisible = false" class="removeInput" style="padding:6px 20px">Cancel</span>
                      <span type="primary" @click="uploadBlock" class="addInput" style="padding:6px 20px;margin-left: 10px;">Confirm</span>
                    </div>

                  </span>
                </div>
              </el-dialog>

              <!-- <div class="select">
                上传类型:
                <el-select v-model="selectType" placeholder="选择上传类型">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <el-input v-model="videoName" placeholder="请输入视频名称" v-if="lookType == 'student' && selectType == 'video'"></el-input>
              <el-input v-model="videoPath" placeholder="请输入视频地址" v-if="lookType == 'student' && selectType == 'video'"></el-input>
              <input class="file" name="file" type="file"  accept="*" @change="getFile" v-if="lookType == 'student' && (selectType == 'pdf' || selectType == 'image')" /><br/>
              <div class="intro">
                附件说明:
                <el-input
                  type="textarea"
                  :rows="5"
                  placeholder="请输入附件说明"
                  style="margin-top:10px;"
                  v-model="intro">
                </el-input>
              </div> -->
              <span class="submitBtn" v-if="lookType == 'student' || lookType == 'admin' " :loading="s_a" @click="submitBlock">Submit</span>

              <span v-if="latest_save_time !='No Records'" style="margin-left:10px;color: #999;font-size: 14px;"  >Last Updated By {{ latest_save_name   + ' on '+  latest_save_time}}</span>
            </div>

          </div>
          <div v-if="content.block_name">
            <div class="addCommets" v-if="lookType !== 'student' ">
                <el-input style="margin-top:10px;"   type="textarea" v-model="educator_comment" ></el-input>
                <el-button style="margin-top:20px" :disabled="!isAnswer && content.block_format !== 'blank'" @click="submitComment">Add a Comment</el-button>

            </div>
            <div class="comments" v-if="comments.length !== 0">
                <!-- <div style="margin-bottom:20px">我的内容：{{my_block}}</div> -->
                Mentor Comments: {{comments.length === 0 ? 'None': ''}}
                <div class="editComments" v-for="(item) in comments" :key="item._id.$id" style="margin-top: 10px;">
                  <p v-if="!item.edit">{{'Mentor Comment on ' + item.timeStr}}</p>
                  <p style="margin-top: 10px;" v-if="!item.edit">{{item.comment_text}}</p>
                  <el-input  v-if="item.edit" style="margin-top:10px;" type="textarea" v-model="item['comment_text']" ></el-input>

                  <el-button size="mini"

                  @click="editComment(item)"
                  v-if="item.educator_id == studentid && !item.edit"
                  >Edit</el-button>
                  <el-button size="mini"

                  @click="editCommentComfirm(item)"
                  v-if="item.educator_id == studentid && item.edit"
                  >Confirm</el-button>
                  <el-button
                  size="mini"

                  :disabled="!isAnswer"
                  v-if="item.educator_id == studentid || lookType=='admin' "
                  @click="delComment(item._id.$id)">Delete</el-button>

                </div>
            </div>
            </div>

        </el-main>
        <!-- <div class="console">
            console
        </div> -->
      </el-container>

    </el-container>


    <el-drawer
      title="Edit History"
      :visible.sync="editHistoryVisible"
      direction="rtl"
      size="560px"
      custom-class="edit-history-drawer"
      :append-to-body="true"
    >
      <div class="edit-history-body" v-loading="editHistoryLoading">
        <div v-if="!editHistoryLoading && editHistoryList.length === 0" class="edit-history-empty">
          No edit records yet.
        </div>
        <ul v-else class="edit-history-list">
          <li v-for="(item, idx) in editHistoryList" :key="item._id || idx" class="edit-history-item">
            <div class="edit-history-row" @click="toggleHistoryItem(idx)">
              <div class="edit-history-meta">
                <el-tag size="mini" :type="actionTagType(item.action)" class="edit-history-tag">
                  {{ actionLabel(item.action) }}
                </el-tag>
                <span class="edit-history-user">{{ item.user_name || 'Unknown' }}</span>
                <span class="edit-history-time">{{ formatHistoryTime(item.save_time) }}</span>
              </div>
              <div class="edit-history-module" v-if="item.block_name || item.block_id">
                {{ item.block_name || getBlockNameById(item.block_id) || '-' }}
              </div>
              <div class="edit-history-brief">{{ briefOf(item) }}</div>
              <i class="el-icon-arrow-down edit-history-caret"
                 :class="{ 'is-open': expandedHistory[idx] }"></i>
            </div>

            <div v-if="expandedHistory[idx]" class="edit-history-detail">
              <!-- update_block: diff 或首次快照 -->
              <template v-if="item.action === 'update_block' && item.payload">
                <div v-if="item.payload.is_snapshot" class="eh-block">
                  <div class="eh-label">Initial content</div>
                  <pre class="eh-snapshot">{{ item.payload.snapshot }}</pre>
                </div>
                <div v-else-if="item.payload.no_change" class="eh-note">
                  No textual change (save without modification)
                </div>
                <div v-else class="eh-block">
                  <div class="eh-label">Changes</div>
                  <div class="eh-diff">
                    <template v-for="(op, oi) in item.payload.diff">
                      <span :key="oi" :class="diffClass(op[0])">{{ op[1] }}</span>
                    </template>
                  </div>
                </div>
              </template>

              <!-- update_check -->
              <template v-else-if="item.action === 'update_check' && item.payload">
                <div class="eh-two-col">
                  <div>
                    <div class="eh-label">Before</div>
                    <pre class="eh-value">{{ formatCheck(item.payload.before) }}</pre>
                  </div>
                  <div>
                    <div class="eh-label">After</div>
                    <pre class="eh-value">{{ formatCheck(item.payload.after) }}</pre>
                  </div>
                </div>
              </template>

              <!-- toggle_check: 勾选/取消单个自检项 -->
              <template v-else-if="item.action === 'toggle_check' && item.payload">
                <div class="eh-block">
                  <div class="eh-label">Check item</div>
                  <pre class="eh-value">{{ item.payload.check_content || '(no text)' }}</pre>
                </div>
                <div class="eh-inline">
                  <span :class="item.payload.before && item.payload.before.checked ? 'eh-ins' : 'eh-del'">
                    {{ item.payload.before && item.payload.before.checked ? '☑ checked' : '☐ unchecked' }}
                  </span>
                  <span class="eh-arrow">→</span>
                  <span :class="item.payload.after && item.payload.after.checked ? 'eh-ins' : 'eh-del'">
                    {{ item.payload.after && item.payload.after.checked ? '☑ checked' : '☐ unchecked' }}
                  </span>
                </div>
              </template>

              <!-- comment actions -->
              <template v-else-if="['add_comment','edit_comment','delete_comment'].includes(item.action) && item.payload">
                <div v-if="item.payload.before" class="eh-block">
                  <div class="eh-label">Before</div>
                  <pre class="eh-value">{{ item.payload.before.comment_text }}</pre>
                </div>
                <div v-if="item.payload.after" class="eh-block">
                  <div class="eh-label">After</div>
                  <pre class="eh-value">{{ item.payload.after.comment_text }}</pre>
                </div>
              </template>

              <!-- attachment actions -->
              <template v-else-if="['add_attach','remove_attach','rename_attach'].includes(item.action) && item.payload">
                <div v-if="item.action === 'rename_attach'" class="eh-inline">
                  <span class="eh-del">{{ item.payload.before && item.payload.before.attach_name }}</span>
                  <span class="eh-arrow">→</span>
                  <span class="eh-ins">{{ item.payload.after && item.payload.after.attach_name }}</span>
                </div>
                <div v-else>
                  <div v-if="item.payload.before" class="eh-block">
                    <div class="eh-label">Removed</div>
                    <div class="eh-attach">
                      <div><b>{{ item.payload.before.attach_name }}</b></div>
                      <div class="eh-sub">{{ item.payload.before.attach_type }} · {{ item.payload.before.attach_address }}</div>
                    </div>
                  </div>
                  <div v-if="item.payload.after" class="eh-block">
                    <div class="eh-label">Added</div>
                    <div class="eh-attach">
                      <div><b>{{ item.payload.after.attach_name }}</b></div>
                      <div class="eh-sub">{{ item.payload.after.attach_type }} · {{ item.payload.after.attach_address }}</div>
                    </div>
                  </div>
                </div>
              </template>

              <!-- result actions -->
              <template v-else-if="['update_result','delete_result'].includes(item.action) && item.payload">
                <div class="eh-two-col">
                  <div>
                    <div class="eh-label">Before</div>
                    <pre class="eh-value">{{ formatResult(item.payload.before) }}</pre>
                  </div>
                  <div>
                    <div class="eh-label">After</div>
                    <pre class="eh-value">{{ formatResult(item.payload.after) }}</pre>
                  </div>
                </div>
              </template>

              <div v-else class="eh-note">No additional details.</div>
            </div>
          </li>
        </ul>
      </div>
    </el-drawer>

    <TeamCreditAvatarCropper
      :visible.sync="avatarCropperVisible"
      :source-url="avatarCropperSource"
      @confirm="onTeamCreditAvatarCropped"
      @closed="onTeamCreditAvatarCropClosed"
    />
  </div>
</template>

<script>
import studentTheme from "../../common/studentTheme"
import {
  getContent, getTemplate,
  updateStudentBlock,
  netService,
  upload,
  sendEmail,
  updateStudentBlockCheck,
  getNIMAICritiqueStatus,
  submitNIMAICritiqueApplication,
  logoutNIMAICritiqueSession,
  uploadBlockAttachNew
} from '../../api/pgservice.js'
import {  getQNToken } from '../../service.js'
import { Loading } from 'element-ui';
import Cookie from 'js-cookie'
// import { removeUserId, getUserId, getUserAccountID, getUserType } from '../../utils/store.js'
import Quiz from './Quiz'
import TeamCreditAvatarCropper from './TeamCreditAvatarCropper.vue'
import * as qiniu from 'qiniu-js'
import {
  createEmptyTeamCreditMember,
  normalizeTeamCreditsContent,
  mapStudentsToMemberOptions,
  buildQiniuPublicUrl,
  resolveDisplayMediaUrl
} from '../../common/teamCredits'

import '../../assets/common/font.css'

export default {
  mixins: [studentTheme],
  name: 'Home',
  props: {
    msg: String
  },
  components: {
    Quiz,
    TeamCreditAvatarCropper
  },
  mounted () {
    // const user_type = getUserType()

    let user_type = 'student'

    if (Cookie.get("loginType") == '学生'){
       user_type = 'student'

       this.studentid = Cookie.get("loginId")
       this.studentAccountId = Cookie.get("loginAccountId")

    }
    if (Cookie.get("loginType") == '教师'){
       user_type = 'adviser'

       this.studentid = this.$router.currentRoute.query.student_id
       this.studentAccountId = this.$router.currentRoute.query.accountid

    }
    if (Cookie.get("loginType") == 'admin'){
        user_type = 'admin'

       this.studentid = Cookie.get("loginId")

    }


    // todo  学生id  lookType 默认学生
    // this.studentid = getUserId()

   
    this.lookType = user_type
    // this.studentAccountId = getUserAccountID()

    

    this.template_id = this.$router.currentRoute.query.template_id
    this.project_id = this.$router.currentRoute.query.project_id
    this.application_id = this.$router.currentRoute.query.application_id || ''
    this.projectTeamRole = this.$router.currentRoute.query.application_team_role || Cookie.get("projectTeamRole") || ''
    this.application_team_code = this.$router.currentRoute.query.application_team_code
    this.accountid = this.$router.currentRoute.query.accountid
    this.now_block_account_id = this.$router.currentRoute.query.accountid
    this.restoreAICritiqueNotificationRetry()
    this.recoverPendingAICritiqueNotification()
    // getProjectTeamcodes({
    //   project_id: this.project_id
    // }).then(data => {
    //   console.log(data)
    // })
    let loadingInstance = Loading.service({
        lock: true,
        text: "Loading...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
    });
    // this.studentId = Cookie.get('studentid')
    getTemplate({ template_id: this.template_id }).then(data => {
      this.contents = data.block_contents
      this.menuItems = this.handleList(data.block_contents)
      this.template_name = data.template_info.template_name
      loadingInstance.close()
      // this.template_description = this.template_info.template_description
    })

    // getContents({session_id: this.session_id,student_id:this.studentId}).then((data) => {
    //   // console.log(data)
    //   this.menuItems = this.handleList(data)
    //   // console.log(this.menuItems)
    // })
  },
  beforeDestroy () {
    Object.keys(this.avatarPreviewUrls || {}).forEach((index) => {
      this.revokeAvatarPreviewUrl(index)
    })
    if (this.avatarCropperObjectUrl) {
      URL.revokeObjectURL(this.avatarCropperObjectUrl)
    }
  },
  methods: {
    logout () {
      // removeUserId()
      console.log('out')
      if (this.studentid && this.aiCritiqueAuthToken) {
        logoutNIMAICritiqueSession({
          student_id: this.studentid,
          auth_token: this.aiCritiqueAuthToken
        }).catch(() => {})
      }
      Cookie.remove('loginId')
      Cookie.remove('nimAICritiqueToken')
      this.$router.push('/login')
    },
    openEditHistory () {
      this.editHistoryVisible = true
      this.expandedHistory = {}
      this.loadEditHistory()
    },
    loadEditHistory () {
      this.editHistoryLoading = true
      this.editHistoryList = []
      netService({
        functionName: 'getProjectEditHistory',
        project_id: this.project_id,
        application_team_code: this.application_team_code,
        account_id: this.accountid,
        template_id: this.template_id
      }).then(data => {
        this.editHistoryLoading = false
        if (Array.isArray(data)) {
          this.editHistoryList = data
        } else if (data && Array.isArray(data.records)) {
          this.editHistoryList = data.records
        } else {
          this.editHistoryList = []
        }
      }).catch(() => {
        this.editHistoryLoading = false
        this.editHistoryList = []
      })
    },
    toggleHistoryItem (idx) {
      this.$set(this.expandedHistory, idx, !this.expandedHistory[idx])
    },
    actionLabel (action) {
      const m = {
        update_block: 'Edit',
        update_check: 'Checklist',
        toggle_check: 'Check ✓',
        add_comment: 'Comment +',
        edit_comment: 'Comment ✎',
        delete_comment: 'Comment −',
        add_attach: 'Attach +',
        remove_attach: 'Attach −',
        rename_attach: 'Attach ✎',
        update_result: 'Result ✎',
        delete_result: 'Result −'
      }
      return m[action] || action || 'Edit'
    },
    actionTagType (action) {
      if (!action) return ''
      if (action.startsWith('add_')) return 'success'
      if (action.startsWith('remove_') || action.startsWith('delete_')) return 'danger'
      if (action === 'toggle_check') return 'warning'
      if (action.startsWith('rename_') || action.startsWith('edit_') || action.startsWith('update_')) return ''
      return 'info'
    },
    diffClass (op) {
      if (op === 1) return 'eh-ins'
      if (op === -1) return 'eh-del'
      return 'eh-eq'
    },
    briefOf (item) {
      const p = item.payload || {}
      if (item.action === 'update_block') {
        if (p.is_snapshot) return 'Initial save'
        if (p.no_change) return 'No change'
        let ins = 0, del = 0
        if (Array.isArray(p.diff)) {
          p.diff.forEach(op => {
            if (op[0] === 1) ins += (op[1] || '').length
            else if (op[0] === -1) del += (op[1] || '').length
          })
        }
        return `+${ins} / −${del} chars`
      }
      if (item.action === 'update_check') return 'Checklist updated'
      if (item.action === 'toggle_check') {
        const was = p.before && p.before.checked
        const now = p.after && p.after.checked
        return now && !was ? 'Checked an item' : (!now && was ? 'Unchecked an item' : 'Toggled a check item')
      }
      if (item.action === 'add_comment') return p.after && p.after.comment_text ? this.truncate(p.after.comment_text, 60) : 'New comment'
      if (item.action === 'edit_comment') return 'Comment edited'
      if (item.action === 'delete_comment') return 'Comment deleted'
      if (item.action === 'add_attach') return p.after && p.after.attach_name ? p.after.attach_name : 'New attachment'
      if (item.action === 'remove_attach') return p.before && p.before.attach_name ? p.before.attach_name : 'Attachment removed'
      if (item.action === 'rename_attach') {
        const a = p.before && p.before.attach_name
        const b = p.after && p.after.attach_name
        return `${a || '?'} → ${b || '?'}`
      }
      if (item.action === 'update_result' || item.action === 'delete_result') return 'Team result updated'
      return ''
    },
    truncate (s, n) {
      if (!s) return ''
      s = String(s)
      return s.length > n ? s.slice(0, n) + '…' : s
    },
    formatCheck (v) {
      if (v == null) return '(empty)'
      if (Array.isArray(v)) return v.join('\n')
      if (typeof v === 'object') return JSON.stringify(v, null, 2)
      return String(v)
    },
    formatResult (v) {
      if (v == null) return '(empty)'
      if (typeof v === 'object') return JSON.stringify(v, null, 2)
      return String(v)
    },
    getBlockNameById (blockId) {
      if (!blockId || !this.contents) return '-'
      const walk = (nodes) => {
        for (const n of nodes) {
          const id = n && n._id && n._id.$id ? n._id.$id : (n && n.block_info && n.block_info.id)
          if (id === blockId) return n.block_info && n.block_info.block_name
          if (n.children && n.children.length) {
            const r = walk(n.children)
            if (r) return r
          }
        }
        return ''
      }
      return walk(this.contents) || '-'
    },
    formatHistoryTime (t) {
      if (!t) return ''
      const ts = typeof t === 'number' ? (t < 1e12 ? t * 1000 : t) : Date.parse(t)
      if (isNaN(ts)) return String(t)
      const d = new Date(ts)
      const pad = n => (n < 10 ? '0' + n : '' + n)
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    closeVideo () {
      this.dialogVisible = false
      this.address = ''
    },
    playVideo (address) {

    console.log(12222,address)
      this.dialogVisible = true
      this.address = address
    },
    openDialog (e) {
      this.videoDialogVisible = true
      this.videoAddress = e
    },
    submitBlock () {
      this.s_a = true
      console.log(this.content, this.application_team_code)
      this.pageLoading = this.$loading({
        lock: true,
        text: 'Submitting...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const blockContent = this.content.block_format === 'select'
        ? this.update_block_content.map(value => this.toPlainText(value))
        : (this.content.block_format === 'team_credits'
          ? this.serializeTeamCreditsContent()
          : this.update_block_content)
      updateStudentBlock({
        team_code: this.application_team_code,
        project_id: this.project_id,
        account_id: this.lookType === 'student' ? this.now_block_account_id : this.accountid,
        block_id: this.content.id,
        block_content: blockContent,
        update_user:this.studentid
      }).then(data => {
        this.s_a = false
        // Success is a JSON null; false means editing is locked; anything else (an error
        // object, or undefined after a network failure) must not pass silently.
        if (data === null) {
          this.$message({
            message: 'Submit Successful',
            type: 'success'
          })
        } else {
          this.$message.error(data === false
            ? 'Editing is locked for this project.'
            : ((data && data.msg) || 'Submit failed. Please try again.'))
        }
      }).finally(() => {
        this.pageLoading && this.pageLoading.close()
      })
    },
    getChecksByBlock (block_id) {
      netService({
        functionName: 'getChecksByBlock',
        block_id,
        project_id: this.project_id,
        team_code: this.application_team_code,
        student_id: this.studentAccountId,
        account_id: (this.lookType === 'student' ? this.now_block_account_id : this.accountid)
      }).then(data => {
        console.log(data, '@!!!!!!')
        this.checklist = data
      })
    },
    handleCheckedCitiesChange (value) {
      const checkId = value.check_id || (value._id && value._id.$id)
      this.switchCheckBlockByStudent(checkId, value.source || value.source_type || 'eae_admin')
    },
    switchCheckBlockByStudent (check_id, source) {
      netService({
        functionName: 'switchCheckBlockByStudent',
        team_code: this.application_team_code,
        student_id: this.studentAccountId,
        update_user: this.studentid,
        account_id: (this.lookType === 'student' ? this.now_block_account_id : this.accountid),
        project_id: this.project_id,
        block_id: this.content.id,
        check_id,
        source
      }).then(data => {
        console.log(data, '@!!!!!!')
        // this.checklist = data
      })
    },
    uploadBlock () {
      this.upLoading = true
      if (this.selectType === 'pdf' || this.selectType === 'image') {
        this.file && this.uploadFile()
        this.centerDialogVisible = false
      }

      if (this.selectType === 'video') {
        this.file && this.uploadVideoFile()
        this.centerDialogVisible = false
      }
      if (this.selectType === 'file' || this.selectType === 'gongzhonghao' || this.selectType === 'website') {
        netService({
          functionName: 'uploadStaticBlockAttach',
          block_id: this.content.id,
          project_id: this.project_id,
          account_id: (this.lookType === 'student' ? this.now_block_account_id : this.accountid),
          team_code: this.application_team_code,
          attach_name: this.videoName,
          attach_type: this.selectType,
          attach_address: this.videoPath,
          attach_intro: this.intro
        }).then(data => {
          console.log(data)
          this.centerDialogVisible = false
          this.upLoading = false
          this.$message({
            message: 'Submit Successful',
            type: 'success'
          })
          this.reload()
        })
      }
    },
    submitComment () {
      netService({
        functionName: 'updateBlockComment',
        project_id: this.project_id,
        team_code: this.application_team_code,
        account_id: this.accountid,
        educator_id: this.studentid,
        student_block_id: this.student_block_id,
        comment_text: this.educator_comment
      }).then(data => {
        console.log(data)
        this.getSB()
      })
    },
    renderContent (h, { node, data }) {
      const children = []
      if (this.content && this.content.id === data.block_info.id) {
        children.push(h('img', { attrs: { src: require('../../assets/newLogo.png') } }))
      }
      children.push(h('span', { attrs: { title: node.label } }, node.label))
      // A parent may also have its own content: keep that accessible explicitly,
      // while clicking its label only expands the navigation without a request.
      if (!node.isLeaf && data.block_info.block_format !== 'blank') {
        children.push(h('button', {
          attrs: { type: 'button', title: 'Open ' + node.label, 'aria-label': 'Open ' + node.label },
          style: { marginLeft: '8px', border: '0', background: 'transparent', color: '#2F509F', cursor: 'pointer' },
          on: { click: event => { event.stopPropagation(); this.handleNodeClick(data, node, true) } }
        }, 'Open'))
      }
      return h('span', { class: 'el-tree-node__label' }, children)
    },
    handleNodeClick (data, node, openParent) {
      if (openParent !== true && ((node && !node.isLeaf) || (data.children && data.children.length))) return
      const nextId = data.block_info && (data.block_info.id || (data._id && data._id.$id))
      if (nextId && this.content.id === nextId) return
      this.contents.map((item) => {
        if (item.block_info.block_name === data.block_info.block_name) {
          if (item.attach_arr.length === 0) {
            this.appendix = false
            this.attach_arr = []
          } else {
            this.appendix = true
            this.attach_arr = (item.attach_arr || []).map((attach) => ({
              ...attach,
              attach_address: resolveDisplayMediaUrl(attach.attach_address),
              attach_avatar_url: attach.attach_avatar_url
                ? resolveDisplayMediaUrl(attach.attach_avatar_url)
                : attach.attach_avatar_url
            }))
          }
        }
      })
      if (data.block_info.block_type === 'VIDEO') {
        getContent({ content_id: data.content_info.id }).then((data) => {
          // console.log(data.content_quiz)
          this.quizsByTimes = {}
          this.isBeginQuiz = false
          this.quizs = []
          this.videoDone = false
          const quizsByTimes = this.quizsByTimes
          this.content_quiz = data.content_quiz
          data.content_quiz.map((v) => {
            if (quizsByTimes[+v.quiz_position]) {
              quizsByTimes[v.quiz_position].push(v)
            } else {
              quizsByTimes[v.quiz_position] = [v]
            }
          })
          // this.quizs = [...data.content_quiz]
          // quizsByTimes
        })
      }
      if (data.block_info.block_format === 'select') {
        console.log(data, 'xxxxxxx')

        this.selectOptions = data.block_info.block_options_array
      }
      if (data.block_info.block_format === 'team_credits') {
        this.selectOptions = data.block_info.block_options_array || []
        this.loadTeamCreditMemberOptions()
      }
      // content important!!!!!!!
      this.content = data.block_info
      if (this.content) {
        if (this.content.pdf_url) {
          this.content.pdf_url = resolveDisplayMediaUrl(this.content.pdf_url)
        }
        if (this.content.video_url) {
          this.content.video_url = resolveDisplayMediaUrl(this.content.video_url)
        }
        if (this.content.html_text) {
          this.content.html_text = resolveDisplayMediaUrl(this.content.html_text)
        }
      }

      this.getBlockAttaches()
      // this.block_id = data._id.$id
      this.getSB()
      this.getChecksByBlock(this.content.id)
      // getContent({content_id: data.content_info.content_id}).then((i) => {
      // })
    },

    getBlockAttaches () {
      netService({
        functionName: 'getBlockAttaches',
        block_id: this.content.id,
        project_id: this.project_id,
        account_id: (this.lookType === 'student' ? this.now_block_account_id : this.accountid),
        team_code: this.application_team_code
      }).then(data => {
        console.log(data)
        this.s_a = false
        this.content_attach = data
        this.content_attach.map((item) => {
          item.attach_address = resolveDisplayMediaUrl(item.attach_address)
          if (item.attach_avatar_url) {
            item.attach_avatar_url = resolveDisplayMediaUrl(item.attach_avatar_url)
          }
        })
      })
    },
    resolveMediaUrl (url) {
      return resolveDisplayMediaUrl(url)
    },
    resolveAttachThumbUrl (url) {
      if (!url) {
        return 'https://i1.wp.com/www.questionpro.com/blog/wp-content/uploads/2015/03/primary-test-it.png?w=293&ssl=1'
      }
      return resolveDisplayMediaUrl(url)
    },
    getSB () {
      const id = (this.lookType === 'student' ? 'student_id' : 'account_id')
      console.log(id, this.accountid)
      this.pageLoading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
      });
      netService({
        functionName: 'getStudentBlock',
        team_code: this.application_team_code,
        project_id: this.project_id,
        [id]: (this.lookType === 'student' ? this.studentid : this.accountid),
        block_id: this.content.id,
        account_id: this.accountid

      }).then(data => {
        console.log(data)
        // this.now_block_account_id = data.account_id
        const storedContent = Array.isArray(data.block_content)
          ? data.block_content
          : (data.block_content ? [data.block_content] : [])
        if (this.content.block_format === 'team_credits') {
          this.update_block_content = normalizeTeamCreditsContent(storedContent)
        } else {
          this.update_block_content = storedContent.length === 0 ? [''] : storedContent
          if (this.content.block_format === 'select') {
            this.update_block_content = this.update_block_content.map(value => this.toPlainText(value))
          }
        }
        if (data.check_content) {
          this.update_check_content = data.check_content
        } else {
          this.update_check_content = new Array(this.update_block_content.length).fill('Pending')
        }
        this.block_content = data.block_content
        if (data.check_content) {
          this.check_content = data.check_content
        }

        let options = { year: 'numeric', month: 'long', day: 'numeric' };


        this.comments = data.block_comments.map(v => {

          const commentDate = new Date(v.create_time * 1000)

          v.timeStr = commentDate.toLocaleDateString("en-US", options)
          v.edit = false
          return v
        })
        const date = new Date(data.latest_save_time * 1000)


        this.latest_save_time = data.latest_save_time ? date.toLocaleDateString("en-US", options) + ' at ' + date.toLocaleTimeString() : 'No Records'
        this.now_save_time = data.latest_save_time

        this.latest_save_name = data.latest_save_name ? data.latest_save_name : ''
        this.isAnswer = !!data._id
        this.student_block_id = data._id.$id

        if (this.lookType !== 'student') {
          if (data.past_content_array) {
            this.past_content_array = data.past_content_array
          }
        }
      }).finally(() => {
        this.pageLoading && this.pageLoading.close()
      })
    },
    handleList (list) {
      const result = []
      list.map(v => {
        this.dfs(result, v)
      })
      return result
    },
    dfs (result, v) {
      // console.log(v, result)
      if (+v.block_info.block_level === 1) {
        result.push({
          label: v.block_info.block_name,
          children: [],
          complete_status: v.complete_status,
          block_info: {
            ...v.block_info,
            id: v._id.$id
          }
        })
      } else {
        const len = result.length
        const l = +v.block_info.block_level
        v.block_info.block_level = l - 1
        v.block_info.block_raw_level = l
        this.dfs(result[len - 1].children, v)
      }
    },
    onQuizDone () {
      this.isBeginQuiz = false
      this.quizs = []
      this.videoDone || this.videoElement.play()
      this.videoDone = false
    },
    timeupdate (event) {
      const currentTime = event.target.currentTime// 获取当前播放时间
      this.videoElement = event.target
      // console.log(currentTime,this.quizsByTimes[~~currentTime],this.quizsByTimes);//在调试器中打印
      if (this.quizsByTimes[~~currentTime]) {
        this.quizs = this.quizsByTimes[~~currentTime]
        setTimeout(() => {
          this.videoElement.pause()
        }, 1000)
        this.isBeginQuiz = true
      }
    },
    videoEnd () {
      if (this.quizsByTimes[-1]) {
        this.quizs = this.quizsByTimes[-1]

        this.isBeginQuiz = true
        this.videoDone = true
      }
    },
    addTextarea () {
      this.update_block_content.push('')
      this.update_check_content.push('Pending')
    },
    removeInput (index) {
      console.log(index)
      this.update_block_content.splice(index, 1)
      this.update_check_content.splice(index, 1)
    },
    createEmptyTeamCreditMember,
    serializeTeamCreditsContent () {
      return (this.update_block_content || []).map(row => {
        const item = row && typeof row === 'object' ? row : createEmptyTeamCreditMember()
        const avatar = item.avatar || item.avatar_url || ''
        return {
          member: item.member || '',
          member_id: item.member_id || '',
          student_email: item.student_email || '',
          role: item.role || '',
          avatar,
          avatar_url: avatar,
          contribution: item.contribution || ''
        }
      })
    },
    addTeamCreditMember () {
      this.update_block_content.push(createEmptyTeamCreditMember())
      if (Array.isArray(this.update_check_content)) {
        this.update_check_content.push('Pending')
      }
    },
    removeTeamCreditMember (index) {
      if (this.update_block_content.length <= 1) {
        return
      }
      this.update_block_content.splice(index, 1)
      if (Array.isArray(this.update_check_content)) {
        this.update_check_content.splice(index, 1)
      }
    },
    isTeamCreditMemberTaken (memberId, currentIndex) {
      if (!memberId) {
        return false
      }
      return (this.update_block_content || []).some((row, idx) => {
        return idx !== currentIndex && row && row.member_id === memberId
      })
    },
    onTeamCreditMemberChange (index, memberId) {
      const opt = (this.teamCreditMemberOptions || []).find(item => item.id === memberId)
      const row = this.update_block_content[index] || createEmptyTeamCreditMember()
      if (!opt) {
        this.$set(this.update_block_content, index, {
          ...row,
          member_id: memberId || '',
          member: memberId || row.member || '',
          student_email: row.student_email || ''
        })
        return
      }
      this.$set(this.update_block_content, index, {
        ...row,
        member_id: opt.id,
        member: opt.name,
        student_email: opt.student_email || '',
        role: row.role || opt.role || ''
      })
    },
    teamCreditAvatarPreview (row, index) {
      const pending = this.avatarPreviewUrls[index]
      if (pending) {
        return pending
      }
      const url = (row && (row.avatar || row.avatar_url)) || ''
      return buildQiniuPublicUrl(url)
    },
    revokeAvatarPreviewUrl (index) {
      const current = this.avatarPreviewUrls[index]
      if (current && String(current).indexOf('blob:') === 0) {
        URL.revokeObjectURL(current)
      }
      if (Object.prototype.hasOwnProperty.call(this.avatarPreviewUrls, index)) {
        this.$delete(this.avatarPreviewUrls, index)
      }
    },
    onTeamCreditAvatarPreviewError (index) {
      const row = this.update_block_content[index]
      if (!row || !row.avatar) {
        return
      }
      this.$message({
        message: 'Avatar preview failed to load. Please upload again.',
        type: 'warning'
      })
    },
    clearTeamCreditAvatar (index) {
      const row = this.update_block_content[index]
      if (!row) {
        return
      }
      this.revokeAvatarPreviewUrl(index)
      this.$set(this.update_block_content, index, {
        ...row,
        avatar: '',
        avatar_url: ''
      })
    },
    onTeamCreditAvatarPick (e, index) {
      const input = e && e.target
      const file = input && input.files && input.files[0]
      if (!file) {
        return
      }
      if (!/^image\//i.test(file.type)) {
        this.$message({ message: 'Please upload an image file (JPG/PNG).', type: 'error' })
        input.value = ''
        return
      }
      if (file.size / 1024 / 1024 > 5) {
        this.$message({ message: 'Avatar image cannot exceed 5 MB.', type: 'error' })
        input.value = ''
        return
      }

      if (this.avatarCropperObjectUrl) {
        URL.revokeObjectURL(this.avatarCropperObjectUrl)
      }
      this.avatarCropperIndex = index
      this.avatarCropperObjectUrl = URL.createObjectURL(file)
      this.avatarCropperSource = this.avatarCropperObjectUrl
      this.avatarCropperVisible = true
      input.value = ''
    },
    onTeamCreditAvatarCropClosed () {
      if (this.avatarCropperObjectUrl) {
        URL.revokeObjectURL(this.avatarCropperObjectUrl)
        this.avatarCropperObjectUrl = ''
      }
      this.avatarCropperSource = ''
      this.avatarCropperIndex = -1
    },
    async onTeamCreditAvatarCropped (blob) {
      const index = this.avatarCropperIndex
      if (index < 0 || !blob) {
        return
      }
      const previewUrl = URL.createObjectURL(blob)
      this.revokeAvatarPreviewUrl(index)
      this.$set(this.avatarPreviewUrls, index, previewUrl)
      await this.uploadTeamCreditAvatarBlob(blob, index)
    },
    async uploadTeamCreditAvatarBlob (blob, index) {
      this.avatarUploadingIndex = index
      this.upLoading = true
      try {
        const result = await this.getQiniuToken()
        if (!result || !result.data || result.data.code !== 0) {
          throw new Error('Unable to prepare the avatar upload.')
        }
        this.proVisible = true
        this.process = 1
        const token = result.data.data
        const key = 'team_credit_avatar_' + Date.now() + '.jpg'
        const file = blob instanceof File
          ? blob
          : new File([blob], 'avatar.jpg', { type: blob.type || 'image/jpeg' })
        await new Promise((resolve, reject) => {
          const observable = qiniu.upload(file, key, token)
          observable.subscribe({
            next: (res) => {
              this.process = parseFloat(res.total.percent.toFixed(1))
            },
            error: (err) => reject(err),
            complete: (res) => {
              const uploadedKey = (res && (res.key || res.name)) || key
              const url = buildQiniuPublicUrl(uploadedKey)
              const row = this.update_block_content[index] || createEmptyTeamCreditMember()
              this.revokeAvatarPreviewUrl(index)
              this.$set(this.update_block_content, index, {
                ...row,
                avatar: url,
                avatar_url: url
              })
              this.$message({ message: 'Avatar uploaded', type: 'success' })
              resolve(url)
            }
          })
        })
      } catch (error) {
        this.revokeAvatarPreviewUrl(index)
        this.$message({
          message: (error && error.message) || 'Avatar upload failed. Please try again.',
          type: 'error'
        })
      } finally {
        this.proVisible = false
        this.upLoading = false
        this.avatarUploadingIndex = -1
      }
    },
    loadTeamCreditMemberOptions () {
      // Template "Select options" are only a last-resort fallback.
      // Never seed the dropdown with them first — they often contain another team's names.
      const fromOptions = (this.selectOptions || this.content.block_options_array || [])
        .filter(Boolean)
        .map(name => ({
          id: String(name),
          name: String(name),
          student_email: '',
          role: ''
        }))
      this.teamCreditMemberOptions = []

      if (!this.project_id) {
        this.teamCreditMemberOptions = fromOptions.slice()
        return
      }

      const normalizeTeamCode = (value) => String(value == null ? '' : value).trim()
      const accountId = String(this.accountid || this.now_block_account_id || '').trim()
      const teamCode = normalizeTeamCode(this.application_team_code)

      const findOwnTeamRow = (rows) => {
        if (!rows || !rows.length) {
          return null
        }
        // Critical: team_code alone is NOT unique across schools in NIM projects.
        // Match account_id + team_code so we never pick another school's "#1".
        if (accountId && teamCode) {
          const exact = rows.find(row => {
            const rowTeam = normalizeTeamCode(row.team_code || row.application_team_code)
            const rowAccount = String(row.account_id || '').trim()
            return rowTeam === teamCode && rowAccount === accountId
          })
          if (exact) {
            return exact
          }
        }
        if (accountId) {
          const byAccount = rows.filter(row => String(row.account_id || '').trim() === accountId)
          if (teamCode) {
            const byAccountTeam = byAccount.find(row => {
              return normalizeTeamCode(row.team_code || row.application_team_code) === teamCode
            })
            if (byAccountTeam) {
              return byAccountTeam
            }
          }
          if (byAccount.length === 1) {
            return byAccount[0]
          }
        }
        if (teamCode) {
          const byTeam = rows.filter(row => {
            return normalizeTeamCode(row.team_code || row.application_team_code) === teamCode
          })
          // Only safe without account_id when the team_code is unique in this result set.
          if (byTeam.length === 1) {
            return byTeam[0]
          }
        }
        if (rows.length === 1) {
          return rows[0]
        }
        return null
      }

      const applyTeamRows = (rows) => {
        const matched = findOwnTeamRow(rows)
        if (!matched) {
          return Promise.resolve(false)
        }
        const students = (matched.studentarr && matched.studentarr.students_arr) ||
          matched.students_arr ||
          []
        let mapped = mapStudentsToMemberOptions(students)
        if (mapped.length) {
          this.teamCreditMemberOptions = mapped
          return Promise.resolve(true)
        }

        // getProjectTeamcodesByStudent rows lack studentarr — fetch roster explicitly.
        const matchedAccount = String(matched.account_id || accountId || '').trim()
        const matchedTeam = normalizeTeamCode(matched.team_code || matched.application_team_code || teamCode)
        if (!matchedAccount || !matchedTeam) {
          return Promise.resolve(false)
        }
        return netService({
          functionName: 'getStudentProfile',
          project_id: this.project_id,
          account_id: matchedAccount,
          team_code: matchedTeam,
          template_id: this.template_id || matched.template_id || ''
        }).then(profile => {
          const profileStudents = (profile && profile.students_arr) || []
          mapped = mapStudentsToMemberOptions(profileStudents)
          if (mapped.length) {
            this.teamCreditMemberOptions = mapped
            return true
          }
          return false
        }).catch(() => false)
      }

      netService({
        functionName: 'getProjectTeamcodes',
        project_id: this.project_id
      }).then(data => {
        const rows = Array.isArray(data) ? data : []
        return applyTeamRows(rows).then(ok => {
          if (ok) {
            return
          }
          if (this.lookType !== 'student' || !this.studentid) {
            return
          }
          return netService({
            functionName: 'getProjectTeamcodesByStudent',
            project_id: this.project_id,
            student_id: this.studentid,
            ecology: Cookie.get('ecology') || ''
          }).then(studentData => applyTeamRows(Array.isArray(studentData) ? studentData : []))
        })
      }).catch(() => {
        if (this.lookType !== 'student' || !this.studentid) {
          if (!this.teamCreditMemberOptions.length) {
            this.teamCreditMemberOptions = fromOptions.slice()
          }
          return
        }
        netService({
          functionName: 'getProjectTeamcodesByStudent',
          project_id: this.project_id,
          student_id: this.studentid,
          ecology: Cookie.get('ecology') || ''
        }).then(data => {
          return applyTeamRows(Array.isArray(data) ? data : []).then(ok => {
            if (!ok && !this.teamCreditMemberOptions.length) {
              this.teamCreditMemberOptions = fromOptions.slice()
            }
          })
        }).catch(() => {
          if (!this.teamCreditMemberOptions.length) {
            this.teamCreditMemberOptions = fromOptions.slice()
          }
        })
      })
    },
    getQiniuToken () {
      return getQNToken()
    },
    async uploadVideoFile () {
      if (!this.file) return
      this.upLoading = true
      try {
        const result = await this.getQiniuToken()
        if (result.data.code !== 0) {
          throw new Error('Unable to prepare the video upload.')
        }
        this.proVisible = true
        this.process = 1

        const token = result.data.data
        this.observable = qiniu.upload(
          this.file,
          new Date().getTime() + this.file.name,
          token
        )
        const observer = {
          complete: (res) => {
            var url = buildQiniuPublicUrl(res.key)

            this.proVisible = false

            this.upLoading = false

            this.uploadVideoC(url)
          },
          error: () => {
            this.proVisible = false
            this.upLoading = false
            this.$message({
              message: 'Video upload failed. Please try again.',
              type: 'error'
            })
          },
          next: (res) => {
            this.process = parseFloat(res.total.percent.toFixed(1))
          }
        }
        this.observable.subscribe(observer)
      } catch (error) {
        this.proVisible = false
        this.upLoading = false
        this.$message({
          message: error.message || 'Video upload failed. Please try again.',
          type: 'error'
        })
      }
    },

    uploadVideoC (url) {
      netService({
        functionName: 'uploadStaticBlockAttach',
        block_id: this.content.id,
        project_id: this.project_id,
        account_id: (this.lookType === 'student' ? this.now_block_account_id : this.accountid),
        team_code: this.application_team_code,
        attach_name: this.videoName,
        attach_type: this.selectType,
        attach_address: url,
        attach_intro: this.intro
      }).then(data => {
        console.log(data)
        this.centerDialogVisible = false
        this.upLoading = false
        this.$message({
          message: 'Submit Successful',
          type: 'success'
        })
        this.getBlockAttaches()
      })
    },

    getBlockFile (e) {
      if (this.content.block_format === 'video') {
        this.selectType = 'video'
        if (this.getVideoFile(e)) {
          this.videoName = this.file.name
          this.intro = ''
          this.uploadVideoFile()
        }
      } else if (this.content.block_format === 'archive') {
        this.selectType = 'archive'
        if (this.getArchiveFile(e)) {
          this.videoName = this.file.name
          this.intro = ''
          this.uploadAttachmentFile()
        }
      } else if (this.content.block_format === 'pdf') {
        this.selectType = 'pdf'
        this.getFile(e)
      } else {
        const file = e.target.files && e.target.files[0]
        if (file) {
          this.selectType = this.inferAttachmentType(file)
        }
        this.getFile(e)
      }
      e.target.value = ''
    },

    inferAttachmentType (file) {
      if (!file) {
        return 'file'
      }
      if (/^image\//i.test(file.type) || /\.(png|jpe?g|gif|webp|bmp|svg|heic|heif)$/i.test(file.name)) {
        return 'image'
      }
      if (file.type === 'application/pdf' || /\.pdf$/i.test(file.name)) {
        return 'pdf'
      }
      return 'file'
    },

    getVideoFile (e) {
      const file = e.target.files && e.target.files[0]
      if (!file) {
        return false
      }
      const hasMp4Extension = /\.mp4$/i.test(file.name)
      const hasMp4MimeType = !file.type || file.type === 'video/mp4' || file.type === 'application/mp4'
      if (!hasMp4Extension || !hasMp4MimeType) {
        this.$message({
          message: 'Please upload an MP4 video.',
          type: 'error'
        })
        this.file = null
        e.target.value = ''
        return false
      }
      if (file.size / 1024 / 1024 > 1024) {
        this.$message({
          message: 'The file size cannot exceed 1024 MB. Please upload again.',
          type: 'error'
        })
        this.file = null
        e.target.value = ''
        return false
      }
      this.file = file
      return true
    },

    getArchiveFile (e) {
      const file = e.target.files && e.target.files[0]
      if (!file) {
        return false
      }
      const allowedExtensions = /\.(zip|rar|7z)$/i
      const allowedMimeTypes = [
        '',
        'application/octet-stream',
        'application/zip',
        'application/x-zip-compressed',
        'multipart/x-zip',
        'application/vnd.rar',
        'application/x-rar',
        'application/x-rar-compressed',
        'application/x-7z-compressed'
      ]
      if (!allowedExtensions.test(file.name) || !allowedMimeTypes.includes(file.type)) {
        this.$message({
          message: 'Please upload a ZIP, RAR, or 7Z archive.',
          type: 'error'
        })
        this.file = null
        e.target.value = ''
        return false
      }
      if (file.size / 1024 / 1024 > 1024) {
        this.$message({
          message: 'The file size cannot exceed 1024 MB. Please upload again.',
          type: 'error'
        })
        this.file = null
        e.target.value = ''
        return false
      }
      this.file = file
      return true
    },


    async uploadAttachmentFile () {
      if (!this.file) return
      this.upLoading = true
      try {
        const result = await this.getQiniuToken()
        if (result.data.code !== 0) {
          throw new Error('Unable to prepare the file upload.')
        }
        this.proVisible = true
        this.process = 1

        const token = result.data.data
        this.observable = qiniu.upload(
          this.file,
          new Date().getTime() + this.file.name,
          token
        )
        const observer = {
          complete: (res) => {
            var url = buildQiniuPublicUrl(res.key)

            this.proVisible = false

            this.upLoading = false

            this.uploadFile(url,res.key)
          },
          error: () => {
            this.proVisible = false
            this.upLoading = false
            this.$message({
              message: 'File upload failed. Please try again.',
              type: 'error'
            })
          },
          next: (res) => {
            this.process = parseFloat(res.total.percent.toFixed(1))
          }
        }
        this.observable.subscribe(observer)
      } catch (error) {
        this.proVisible = false
        this.upLoading = false
        this.$message({
          message: error.message || 'File upload failed. Please try again.',
          type: 'error'
        })
      }
    },

    getFile (e) {
      const file = e.target.files && e.target.files[0]

      if (!file) {
        return false
      }
      if (file.size / 1024 / 1024 > 20) {
        this.$message({
          message: 'The file size cannot exceed 20 MB. Please upload again.',
          type: 'error'
        })
        this.file = null
        return false
      } else {
        this.file = file
      }

      console.log(123,this.file)

      this.videoName = this.file.name
      this.uploadAttachmentFile()
    },
    uploadFile (url,key) {


      


      netService({
        functionName: 'uploadBlockAttachNew',
        block_id: this.content.id,
        project_id: this.project_id,
        account_id: (this.lookType === 'student' ? this.now_block_account_id : this.accountid),
        team_code: this.application_team_code,
        attach_name: this.videoName,
        attach_type: this.selectType,
        attach_address: url,
        key: key,
        attach_intro: this.intro
      }).then(data => {
        console.log(data)
        this.centerDialogVisible = false
        this.upLoading = false
        this.$message({
          message: 'Submit Successful',
          type: 'success'
        })
        this.getBlockAttaches()
      })


      // const param = new FormData() // 创建form对象
      // const _this = this
      // this.proVisible = true
      // this.process = '0'
      // param.append('file', this.file)// 通过append向form对象添加数据

      // param.append('function', 'uploadBlockAttach')
      // param.append('project_id', this.project_id)
      // param.append('attach_type', this.selectType)
      // param.append('attach_intro', this.intro)
      // param.append('team_code', this.application_team_code)
      // param.append('account_id', (this.lookType === 'student' ? this.now_block_account_id : this.accountid))
      // param.append('block_id', this.content.id)
      // param.append('attach_name', this.videoName)

      // console.log(param.get('file')) // FormData私有类对象，访问不到，可以通过get判断值是否传进去
      // const config = {
      //   headers: { 'Content-Type': 'multipart/form-data' },
      //   onUploadProgress: function (progressEvent) { // 原生获取上传进度的事件
      //     console.log(progressEvent)
      //     if (progressEvent.lengthComputable) {
      //       // 属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
      //       // 如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
      //       const loaded = progressEvent.loaded
      //       const total = progressEvent.total
      //       _this.$nextTick(() => {
      //         _this.process = parseFloat(((loaded / total) * 100).toFixed(1))
      //       })
      //       console.log(_this.process)
      //     }
      //   }
      // } // 添加请求头
      // upload({ param, config })
      //   .then(response => {
      //     console.log(response.data)
      //     this.$message({
      //       message: 'Submit Successful',
      //       type: 'success'
      //     })
      //     this.upLoading = false
      //     this.proVisible = false
      //     this.getBlockAttaches()
      //   })
    },

    deleteAttach (index) {
      netService({
        functionName: 'removeBlockAttach',

        attach_id: this.content_attach[index]._id.$id,
        project_id: this.project_id,
        account_id: (this.lookType === 'student' ? this.now_block_account_id : this.accountid),
        team_code: this.application_team_code,
        student_id: this.lookType === 'student' ? this.studentid : ''

      }).then(data => {
        // console.log(data)
        this.getBlockAttaches()
      })
      return false
    },
    toPlainText (value) {
      if (value == null) return ''
      const element = document.createElement('div')
      element.innerHTML = String(value).replace(/<(?:br\b[^>]*|\/p\s*|\/div\s*|\/li\s*)>/gi, ' ')
      return (element.textContent || element.innerText || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim()
    },
    editAttach (index) {
      this.content_attach[index].edit = true
      this.content_attach = [...this.content_attach]
    },
    confirmAttach (index) {
      this.content_attach[index].edit = false

      netService({
        functionName: 'updateAttachName',

        attach_id: this.content_attach[index]._id.$id,
        new_name: this.content_attach[index].attach_name
      }).then(data => {
        // console.log(data)
        this.getBlockAttaches()
      })
    },
    delComment (id) {
      console.log(id)
      netService({
        functionName: 'deleteBlockComment',

        student_block_id: this.student_block_id,
        comment_id: id

      }).then(data => {
        // console.log(data)
        this.getSB()
      })
    },

    editComment (item) {
      item.edit = true
      this.comments = {
        ...this.comments
      }
      console.log(this.comments)
    },

    editCommentComfirm (item) {
      netService({
        functionName: 'editBlockComment',

        comment_id: item._id.$id,
        comment_text: item.comment_text

      }).then(data => {
        // console.log(data)
        this.getSB()
      })
    },
    getPdf () {
      if (!this.application_id) {
        this.$message.error('The project application is not available. Please reopen this project from the list.')
        return
      }
      window.open('https://www.nextideamatters.com/#/project?id=' + encodeURIComponent(this.application_id), '_blank', 'noopener,noreferrer')
    },

    closeDialog () {
      this.videoDialogVisible = false
      this.videoAddress = ''
    },

    changePage (e) {
      console.log(e)
      if (e !== 1) {
        const index = e - 2
        const pastContent = this.past_content_array[index].block_content
        this.update_block_content = this.content.block_format === 'team_credits'
          ? normalizeTeamCreditsContent(pastContent)
          : pastContent
        if (this.past_content_array[index].check_content) {
          this.update_check_content = this.past_content_array[index].check_content
        } else {
          this.update_check_content = new Array(this.update_block_content.length).fill('Pending')
        }
        const date = new Date(this.past_content_array[index].save_time * 1000)
        let options = { year: 'numeric', month: 'long', day: 'numeric' };

        this.latest_save_time = this.past_content_array[index].save_time ? date.toLocaleDateString("en-US", options) + ' at ' + date.toLocaleTimeString() : 'No Records'
      } else {
        this.update_block_content = this.content.block_format === 'team_credits'
          ? normalizeTeamCreditsContent(this.block_content)
          : this.block_content
        if (this.check_content) {
          this.update_check_content = this.check_content
        } else {
          this.update_check_content = new Array(this.update_block_content.length).fill('Pending')
        }
        const date = new Date(this.now_save_time * 1000)
        let options = { year: 'numeric', month: 'long', day: 'numeric' };

        this.latest_save_time = this.now_save_time ? date.toLocaleDateString("en-US", options) + ' at ' + date.toLocaleTimeString() : 'No Records'
      }
    },
    sendEmail () {
      sendEmail(this.studentid, this.project_id).then(res => {
        this.$message({
          message: 'Submit Successful',
          type: 'success'
        })
      })
    },
    updateCheck () {
      updateStudentBlockCheck(this.content.id, this.project_id, this.application_team_code, this.accountid, this.update_check_content, Cookie.get('loginId')).then(res => {
        this.$message.success('Update Success')
      })
    },

    showAICritiqueExhausted () {
      return this.$alert('Your team has used both AI Critique requests.', 'AI Critique', {
        confirmButtonText: 'Confirm'
      })
    },
    createAICritiqueRequestId () {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID()
      }

      return `nim-ai-critique-${this.application_id}-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`
    },
    aiCritiqueRetryStorageKey () {
      return `nim-ai-critique-notification-retry:${this.application_id}:${this.studentid}`
    },
    restoreAICritiqueNotificationRetry () {
      if (!this.application_id || !this.studentid) return

      try {
        const stored = JSON.parse(window.sessionStorage.getItem(this.aiCritiqueRetryStorageKey()) || 'null')
        if (stored && stored.requestId) {
          this.aiCritiqueRequestId = stored.requestId
          this.aiCritiquePendingRequestNo = Number(stored.requestNo || 0)
          this.aiCritiqueNotificationPending = true
        }
      } catch (error) {
        window.sessionStorage.removeItem(this.aiCritiqueRetryStorageKey())
      }
    },
    persistAICritiqueNotificationRetry () {
      try {
        window.sessionStorage.setItem(this.aiCritiqueRetryStorageKey(), JSON.stringify({
          requestId: this.aiCritiqueRequestId,
          requestNo: this.aiCritiquePendingRequestNo
        }))
      } catch (error) {
        // The in-memory retry state remains available when storage is disabled.
      }
    },
    clearAICritiqueNotificationRetry () {
      if (this.application_id && this.studentid) {
        try {
          window.sessionStorage.removeItem(this.aiCritiqueRetryStorageKey())
        } catch (error) {
          // Ignore browsers that block session storage.
        }
      }
    },
    recoverPendingAICritiqueNotification () {
      if (this.lookType !== 'student'
        || this.projectTeamRole !== '领队'
        || !this.application_id
        || !this.studentid
        || !this.aiCritiqueAuthToken) {
        return
      }

      const retryNotification = () => {
        this.aiCritiqueChecking = false
        this.aiCritiqueSubmitting = true
        return this.submitAICritiqueRequest(this.aiCritiquePendingRequestNo, 2, true)
      }

      let recovery
      if (this.aiCritiqueNotificationPending && this.aiCritiqueRequestId) {
        recovery = retryNotification()
      } else {
        this.aiCritiqueChecking = true
        recovery = getNIMAICritiqueStatus({
          application_id: this.application_id,
          student_id: this.studentid,
          auth_token: this.aiCritiqueAuthToken
        }).then(res => {
          const status = res && res.data ? res.data : {}
          if (res && (res.code === -403 || status.visible === false || status.is_leader === false)) {
            this.aiCritiqueVisible = false
            return
          }
          if (!res || res.code !== 0 || !status.pending_notification_request_id) {
            return
          }

          this.aiCritiqueRequestId = status.pending_notification_request_id
          this.aiCritiquePendingRequestNo = Number(status.pending_notification_request_no || 0)
          this.aiCritiqueNotificationPending = true
          this.persistAICritiqueNotificationRetry()
          return retryNotification()
        })
      }

      recovery.catch(() => {
        // Keep the retry state; the leader can retry from the AI Critique button.
      }).finally(() => {
        this.aiCritiqueChecking = false
        this.aiCritiqueSubmitting = false
      })
    },
    submitAICritiqueRequest (requestNo, maxRequests, isNotificationRetry = false) {
      return submitNIMAICritiqueApplication({
        application_id: this.application_id,
        student_id: this.studentid,
        request_id: this.aiCritiqueRequestId,
        auth_token: this.aiCritiqueAuthToken
      }).then(submitRes => {
        const submitData = submitRes && submitRes.data ? submitRes.data : {}
        const quotaExhausted = submitRes && submitRes.code !== 0 && (
          submitRes.code === -3 ||
          submitData.can_apply === false ||
          submitData.exhausted === true
        )

        if (quotaExhausted) {
          this.aiCritiqueNotificationPending = false
          this.aiCritiqueRequestId = ''
          this.clearAICritiqueNotificationRetry()
          return this.showAICritiqueExhausted()
        }

        if (!submitRes || submitRes.code !== 0) {
          if (submitRes && submitRes.code === -409) {
            this.aiCritiqueNotificationPending = false
            this.aiCritiqueRequestId = ''
            this.clearAICritiqueNotificationRetry()
          }
          throw new Error((submitRes && submitRes.msg) || 'Unable to submit the AI Critique request.')
        }

        const submittedRequestNo = Number(submitData.request_no || submitData.used_count || requestNo)
        const submittedMaxRequests = Number(submitData.max_requests || submitData.max_count || maxRequests || 2)
        if (submitData.notifications_complete === false) {
          this.aiCritiqueNotificationPending = true
          this.aiCritiquePendingRequestNo = submittedRequestNo
          this.persistAICritiqueNotificationRetry()
          this.$message.warning('Your AI Critique request was saved, but one or more notifications are still pending. Select Retry Notification to try again.')
          return
        }

        this.aiCritiqueNotificationPending = false
        this.aiCritiquePendingRequestNo = 0
        this.aiCritiqueRequestId = ''
        this.clearAICritiqueNotificationRetry()
        if (isNotificationRetry) {
          this.$message.success(`Notifications for AI Critique request ${submittedRequestNo}/${submittedMaxRequests} were delivered successfully.`)
        } else {
          this.$message.success(`AI Critique request ${submittedRequestNo}/${submittedMaxRequests} submitted successfully.`)
        }
      }).catch(error => {
        if (this.aiCritiqueRequestId) {
          this.aiCritiqueNotificationPending = true
          this.aiCritiquePendingRequestNo = Number(requestNo || 0)
          this.persistAICritiqueNotificationRetry()
        }
        throw error
      })
    },
    requestAICritique () {
      if (this.aiCritiqueChecking || this.aiCritiqueSubmitting) {
        return
      }

      if (this.aiCritiqueNotificationPending && this.aiCritiqueRequestId) {
        this.aiCritiqueSubmitting = true
        this.submitAICritiqueRequest(this.aiCritiquePendingRequestNo, 2, true)
          .catch(error => {
            this.$message.error(error.message || 'Unable to retry the notification. Please try again.')
          })
          .finally(() => {
            this.aiCritiqueSubmitting = false
          })
        return
      }

      this.aiCritiqueChecking = true

      getNIMAICritiqueStatus({
        application_id: this.application_id,
        student_id: this.studentid,
        auth_token: this.aiCritiqueAuthToken
      }).then(res => {
        const status = res && res.data ? res.data : {}

        if (res && (res.code === -403 || status.visible === false || status.is_leader === false)) {
          this.aiCritiqueVisible = false
          return
        }

        if (!res || res.code !== 0) {
          throw new Error((res && res.msg) || 'Unable to load the AI Critique request status.')
        }

        if (status.pending_notification_request_id) {
          this.aiCritiqueRequestId = status.pending_notification_request_id
          this.aiCritiquePendingRequestNo = Number(status.pending_notification_request_no || 0)
          this.aiCritiqueNotificationPending = true
          this.persistAICritiqueNotificationRetry()
          this.aiCritiqueChecking = false
          this.aiCritiqueSubmitting = true
          return this.submitAICritiqueRequest(this.aiCritiquePendingRequestNo, 2, true)
        }

        const usedCount = Number(status.used_count || 0)
        const maxRequests = Number(status.max_requests || status.max_count || 2)
        if (status.can_apply === false || status.exhausted === true || usedCount >= maxRequests) {
          return this.showAICritiqueExhausted()
        }

        const requestNo = Number(status.next_request_no || usedCount + 1)
        const message = `Each team may request up to two AI critiques. This is request ${requestNo} of 2 for your team. Would you like to submit it now?`

        return this.$confirm(message, 'AI Critique', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel'
        }).then(() => {
          this.aiCritiqueChecking = false
          this.aiCritiqueSubmitting = true

          if (!this.aiCritiqueRequestId) {
            this.aiCritiqueRequestId = this.createAICritiqueRequestId()
          }

          return this.submitAICritiqueRequest(requestNo, maxRequests)
        })
      }).catch(error => {
        if (error === 'cancel' || error === 'close') {
          return
        }

        this.$message.error(error.message || 'Unable to submit the AI Critique request. Please try again.')
      }).finally(() => {
        this.aiCritiqueChecking = false
        this.aiCritiqueSubmitting = false
      })
    },

  },
  computed: {
    blockUploadConfig () {
      if (this.content.block_format === 'video') {
        return {
          accept: '.mp4,video/mp4',
          ariaLabel: 'Upload an MP4 video',
          label: 'Upload MP4 Video',
          hint: 'MP4 only · Maximum 1 GB'
        }
      }
      if (this.content.block_format === 'archive') {
        return {
          accept: '.zip,.rar,.7z,application/zip,application/vnd.rar,application/x-rar-compressed,application/x-7z-compressed',
          ariaLabel: 'Upload a ZIP, RAR, or 7Z archive',
          label: 'Upload Archive',
          hint: 'ZIP, RAR, or 7Z · Maximum 1 GB'
        }
      }
      if (this.content.block_format === 'pdf') {
        return {
          accept: '.pdf,application/pdf',
          ariaLabel: 'Upload a PDF attachment',
          label: 'Add an Attachment',
          hint: 'Maximum 20 MB'
        }
      }
      return {
        accept: '*',
        ariaLabel: 'Upload an attachment',
        label: 'Add an Attachment',
        hint: 'Maximum 20 MB'
      }
    }
  },
  data () {
    return {
      pageLoading: false,
      activeC: 'default',
      s_a: false,
      isAnswer: false,
      educator_comment: '',
      lookType: 'student',
      latest_save_time: '',
      latest_save_name:'',
      template_description: '',
      template_name: '',
      videoDone: false,
      process: '0',
      proVisible: false,

      update_block_content: [''],
      update_check_content: '',
      my_block: '',
      comments: [],

      videoElement: null,
      session_id: '',
      menuItems: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        content_info: 'content_info'
      },
      checklist: [],
      content: {},
      studentId: '',
      quizs: [],
      isBeginQuiz: false,
      quizsByTimes: {},
      content_quiz: [],

      content_attach: [],
      activeNames: ['1', 'appendix'],
      file: null,
      studentid: '',
      nowAttachName: '',
      past_content_array: [],
      block_content: [],
      check_content: '',
      options: [{
        value: 'video',
        label: 'video'
      }, {
        value: 'pdf',
        label: 'pdf'
      }, {
        value: 'image',
        label: 'image'
      }, {
        value: 'file',
        label: 'Cloud Storage'
      }, {
        value: 'gongzhonghao',
        label: 'Blog'
      }, {
        value: 'website',
        label: 'Website'
      }],
      selectType: 'pdf',
      videoPath: '',
      videoName: '',
      intro: '',
      centerDialogVisible: false,
      upLoading: false,

      selectOptions: [],
      selectValue: '',
      teamCreditMemberOptions: [],
      avatarUploadingIndex: -1,
      avatarCropperVisible: false,
      avatarCropperSource: '',
      avatarCropperIndex: -1,
      avatarCropperObjectUrl: '',
      avatarPreviewUrls: {},
      attach_arr: [],
      appendix: false,
      dialogVisible: false,
      videoDialogVisible: false,
      videoAddress: '',
      address: '',
      now_block_account_id: '',
      accountid: '',
      application_id: '',
      projectTeamRole: '',
      aiCritiqueVisible: true,
      aiCritiqueChecking: false,
      aiCritiqueSubmitting: false,
      aiCritiqueRequestId: '',
      aiCritiqueNotificationPending: false,
      aiCritiquePendingRequestNo: 0,
      aiCritiqueAuthToken: Cookie.get("nimAICritiqueToken") || '',
      editHistoryVisible: false,
      editHistoryLoading: false,
      editHistoryList: [],
      expandedHistory: {},
      contents: [],
      editorOption: {
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
                        ['blockquote', 'code-block'], // 引用  代码块
                        [{ header: 1 }, { header: 2 }], // 1、2 级标题
                        [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
                        [{ script: 'sub' }, { script: 'super' }], // 上标/下标
                        [{ indent: '-1' }, { indent: '+1' }], // 缩进
                        // [{'direction': 'rtl'}],                         // 文本方向
                        [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
                        [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
                        [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
                        [{ font: [] }], // 字体种类
                        [{ align: [] }], // 对齐方式
                        ['clean'], // 清除文本格式
                        ['link', 'image', 'video'] // 链接、图片、视频
                    ] // 工具菜单栏配置
                },
                placeholder: '', // 提示
                readyOnly: false, // 是否只读
                theme: 'snow', // 主题 snow/bubble
                syntax: true // 语法检测,
            },

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.Home{
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #F5F9FF;
  .head{
    height: 50px;
    background: #204386;
    // background: url('../../assets/pg/header.png');
    background-size: 100% 100%;
    background-position: 0 0;
    line-height: 50px;
    text-align: right;
    .el-icon-setting{
      color: #fff;
      font-size: 18px;
    }
    .btn{
      border: 1.5px solid #fff;
      padding: 1px 12px;
      border-radius: 5px;
      color: #fff;
      font-size: 14px;
      text-align: center;
      margin-right: 18px;
      cursor: pointer;
    }
    .btnAttachment{
      border: 1.5px solid #fff;
      padding: 1px 12px;
      border-radius: 5px;
      color: #fff;
      font-size: 14px;
      text-align: center;
      margin-right: 18px;
      clear: both;
      // flex-direction: row;
      // margin-top: 30px;
      cursor: pointer;
    }
  }
  .center{
    flex:1;
    overflow: hidden;
    .aside{
      height: 100%;
      background: #FFFFFF;
      box-shadow: 0px 0px 8px 1px #CEC9C7;
      padding: 0;
      margin: 0;
      ::v-deep .el-collapse-item__header{
        padding: 0px 20px!important;
        height: 60px;
        color: #204386;
        font-weight: bold;
        font-size: 18px;
        border: none;
      }
      ::v-deep .el-collapse{
        border: none;
      }
      ::v-deep .el-collapse-item__wrap{
        border:none
      }
    }
    .centerMain{
      ::v-deep .el-collapse-item__header{
        font-family: "DDINAlternateRegular";
        color: #0E4890;
        border: none;
        height: 20px;
        // background-color: red;
        .el-collapse-item__arrow{
          margin: 0;
          margin-left: 16px;
          font-weight: bold;
        }
      }
      ::v-deep .el-collapse{
        border: none;
      }
      ::v-deep .el-collapse-item__wrap{
        border:none
      }
    }
    .submitBtn{
      display: inline-block;
      margin-top: 36px;
      padding: 6px 20px;
      background: #204386;
      color: #fff;
      border-radius: 5px;
      cursor: pointer;
      font-weight: bold;
    }
    .submitBtn1{
      display: inline-block;
      margin-top: 36px;
      padding: 6px 20px;
      background: white;
      color: #0E4890;
      border: 1.5px solid #0E4890;
      // color: #fff;
      border-radius: 5px;
      cursor: pointer;
      font-weight: bold;
    }
  }
}
.attach-img{
  /*width:100%;*/
  /*margin-bottom:50px;*/
  /*width: 200px;*/
  height: 150px;
  display: block;
  margin:0 auto 10px auto;
  border:1px solid #ddd;
  font-family: "DDINAlternateRegular";
}
.check-box{
  margin-top: 10px;
  border-radius: 5px;
  background: #F5F9FF;
  padding: 20px;
  font-family: "DDINAlternateRegular";
  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #0E4890!important;
      border-color: #0E4890!important;
  }
  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #0E4890!important;
}
}
.check-box-item{
  /* word-wrap:break-word;
word-break:break-all;  */
word-break:normal;
white-space: pre-wrap;
margin-bottom: 10px;
font-weight: bold;
font-size: 14px;
  font-family: "DDINAlternateRegular";
}
.video_container {
  height: 600px;
  background-color:clear;
}
.video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%)
}
.appendix {
  margin: 20px;
  font-size: 12px;
  display: flex;
  // align-items: center;
  flex-wrap: wrap;
  font-family: "DDINAlternateRegular";
  /* display: grid;
  grid-template-columns: 300px 300px 300px;
  grid-template-rows: 300px 300px 300px; */
  a{
    color: #204386;
    font-size: 14px;
  }
}
.attach_arr {
  margin: 20px 0;
}
.attach_arr p {
  font-size: 13px;
}
.select {
  margin: 20px 0;
}
.intro {
  margin-top: 20px;

}
.pdf{
  position: absolute;
  right: 0;
  top: 5px;
}
.file{
  // display:none;
  margin-top: 20px;
}
.templateHead{
  position: relative;
  padding: 0 10px;
  height: 50px;
}
.comments{
  margin-top: 30px;
  color: #888;
}
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
    font-family: "DDINAlternateRegular";
  }

  .el-aside {
    color: #333;
  }
  .console{
    position: absolute;
    bottom: 0;
    height: 300px;
    width: calc(100% - 201px);
    border-top: 1px solid #ccc;
    font-family: "DDINAlternateRegular";
  }
  .toptitle{
    font-family: DIN Alternate-Bold, DIN Alternate;
    font-weight: bold;
    color: #0E4890;
    font-size: 20px;
    margin-top: 30px;
    // height: 30px;
    // background-color: rebeccapurple;
      .tip{
        margin-left: 10px;
        font-size: 60%;
        background: #c9cae4;
        color: #204386;
        border-radius: 20px;
        // height: 30px;
        padding: 4px 8px;
        font-family: "DDINAlternateRegular";
      }

  }
  #videoPlay{
    width: 100%;
  }
  .title-description{
    font-size: 14px;
    display: contents;
    font-family: "DDINAlternateRegular";
  }
  .content_instruction{
    display: block;
    font-family: DIN Alternate-Bold, DIN Alternate;
    font-weight: bold;
    color: #474747;
    margin-top: 34px;
    line-height: 26px;
    margin-bottom: 20px;
  }
  .deleteAttach{
    cursor: pointer;
    margin-left: 10px;
    padding: 2px 10px;
    border-radius: 5px;
    color: #0E4890;
    border: 1.5px solid #0E4890;
  }
.progress{
  width: 300px;
}
.attachItem{
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #F5F9FF;
  border-radius: 5px;
  padding: 20px;
  margin-top: 10px;
  .attachType {
    display: inline-block;
    margin-right: 10px;
    font-size: 16px;
    font-family: "DDINAlternateRegular";
    font-weight: 400;
    color: #666666;
  }
  .attach{
    color: #0E4890;
    font-size: 16px;
  }
}

.removeInput{
  font-family: "DDINAlternateRegular";
  font-weight: 600;
  color: #0E4890;
  border: 1.5px solid #0E4890;
  border-radius: 5px;
  padding: 3px 12px;
  cursor: pointer;
}
.addInput1{
  font-family: "DDINAlternateRegular";
  font-weight: 600;
  color: #0E4890;
  border: 1.5px solid #0E4890;
  background: white;
  border-radius: 5px;
  padding: 4px 12px;
  cursor: pointer;
  margin-top: 30px;
  display: inline-block;
}

.teamCreditsWrap {
  margin-top: 20px;
}

.teamCreditBlock {
  border: 1px solid #d9e2ec;
  border-radius: 8px;
  padding: 16px 18px 18px;
  margin-bottom: 16px;
  background: #f8fbff;
}

.teamCreditBlockHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.teamCreditBlockTitle {
  font-family: "DDINAlternateRegular";
  font-weight: 700;
  color: #0E4890;
  font-size: 15px;
}

.teamCreditField {
  margin-bottom: 14px;
}

.teamCreditMemberRoleRow {
  display: flex;
  gap: 16px;
  margin-bottom: 14px;
}

.teamCreditFieldHalf {
  flex: 1;
  min-width: 0;
  margin-bottom: 0;
}

.teamCreditLabel {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #445;
}

.teamCreditAvatarRow {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.teamCreditAvatarPreview {
  width: 96px;
  height: 96px;
  border-radius: 4px;
  border: 1px dashed #9db4cc;
  background: #fff;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.teamCreditAvatarPreview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.teamCreditAvatarEmpty {
  color: #99a;
  font-size: 11px;
  text-align: center;
  padding: 8px;
  line-height: 1.3;
}

.teamCreditAvatarActions {
  min-width: 0;
}

.teamCreditAvatarUploadBtn {
  position: relative;
  display: inline-block;
  font-family: "DDINAlternateRegular";
  font-weight: 600;
  color: #0E4890;
  border: 1.5px solid #0E4890;
  background: white;
  border-radius: 5px;
  padding: 4px 12px;
  cursor: pointer;
  overflow: hidden;
}

.teamCreditAvatarUploadBtn input {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.teamCreditAvatarClear {
  margin-left: 10px;
  color: #999;
  cursor: pointer;
  font-size: 13px;
}

.teamCreditAvatarHint {
  margin: 8px 0 0;
  color: #888;
  font-size: 12px;
}

.addInput2{
  font-family: "DDINAlternateRegular";
  font-weight: 600;
  color: #0E4890;
  border: 1.5px solid #0E4890;
  background: white;
  border-radius: 5px;
  padding: 4px 12px;
  cursor: pointer;
  margin-top: 30px;
  display: inline-block;
}
.blockUploadHint{
  display: inline-block;
  margin-left: 10px;
  color: #777;
  font-family: "DDINAlternateRegular";
  font-size: 13px;
}
.myFileUpload
{
    position: absolute;
    display: block;
    cursor: pointer;
    // width: 100px;
    // height: 40px;
    top: 30px;
    // background-color: rebeccapurple;
    opacity: 0;
    // top: 10px;
}
.addInput{
  font-family: "DDINAlternateRegular";
  font-weight: 600;
  color: #fff;
  border: 1.5px solid #0E4890;
  background: #0E4890;
  border-radius: 5px;
  padding: 4px 12px;
  cursor: pointer;
  margin-top: 20px;
  display: inline-block;
}
.edit-history-body {
  min-height: 120px;
  padding: 0 20px 20px;
}
.edit-history-empty {
  color: #999;
  text-align: center;
  padding: 40px 0;
  font-size: 14px;
}
.edit-history-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.edit-history-item {
  border-bottom: 1px solid #eee;
  font-size: 13px;
}
.edit-history-item:last-child {
  border-bottom: none;
}
.edit-history-row {
  position: relative;
  padding: 12px 24px 12px 0;
  cursor: pointer;
}
.edit-history-row:hover {
  background: #fafbfd;
}
.edit-history-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  color: #666;
}
.edit-history-tag {
  flex-shrink: 0;
}
.edit-history-user {
  font-weight: 600;
  color: #204386;
}
.edit-history-time {
  margin-left: auto;
  color: #999;
  font-size: 12px;
}
.edit-history-module {
  color: #333;
  font-size: 13px;
  margin-bottom: 2px;
}
.edit-history-brief {
  color: #888;
  font-size: 12px;
}
.edit-history-caret {
  position: absolute;
  right: 4px;
  top: 16px;
  color: #bbb;
  transition: transform .2s;
}
.edit-history-caret.is-open {
  transform: rotate(180deg);
}
.edit-history-detail {
  padding: 12px 14px;
  margin: 0 0 12px;
  background: #f5f7fa;
  border-radius: 4px;
  font-size: 12px;
}
.eh-label {
  color: #909399;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: .5px;
  margin-bottom: 4px;
}
.eh-block + .eh-block {
  margin-top: 10px;
}
.eh-snapshot,
.eh-value {
  margin: 0;
  padding: 8px 10px;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 3px;
  max-height: 240px;
  overflow: auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', monospace;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-word;
  color: #303133;
}
.eh-diff {
  padding: 8px 10px;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 3px;
  max-height: 280px;
  overflow: auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', monospace;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.55;
}
.eh-eq { color: #606266; }
.eh-ins {
  background: #e6ffed;
  color: #22863a;
  padding: 0 1px;
  border-radius: 2px;
}
.eh-del {
  background: #ffeef0;
  color: #cb2431;
  padding: 0 1px;
  border-radius: 2px;
  text-decoration: line-through;
}
.eh-two-col {
  display: flex;
  gap: 10px;
}
.eh-two-col > div { flex: 1; min-width: 0; }
.eh-inline {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 0;
}
.eh-arrow { color: #909399; }
.eh-attach {
  padding: 8px 10px;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 3px;
}
.eh-sub {
  color: #909399;
  font-size: 11px;
  margin-top: 2px;
  word-break: break-all;
}
.eh-note {
  color: #909399;
  font-style: italic;
}
.aside .el-collapse-transition { transition:none !important; }
</style>
<style lang="scss">
.edit-history-drawer .el-drawer__header {
  color: #204386;
  font-weight: 600;
  margin-bottom: 10px;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}
.addCommets .el-textarea__inner{
  height: 100px;
}

.editComments .el-textarea__inner{
  height: 100px;
}
.el-textarea__inner{
height: 350px;
}
.intro .el-textarea__inner{
    height: 150px;

}
.btn {
  margin: 20px 0;
}
.green{
  color: green
}
.el-tree-node{
  white-space: normal!important;
  background: #fff;
  color: #8D8D8D;
}
.el-tree-node__content{
  padding: 2px 0!important;
}
.el-tree-node__content:hover{
  background: #204386;
  color: #fff;
}
.el-tree-node:focus>.el-tree-node__content {
    background-color: #204386;
    color: #fff;
}
.el-tree-node__content{
    padding: 2px 0;

  }
  .el-tree-node__label{
    /* overflow: hidden;
    text-overflow: ellipsis; */
    display: flex;
    align-items: center;
    img{
      width:24px;
      margin-right: 10px;
    }
  }
  .el-tree-node__expand-icon + .el-tree-node__label{
    font-weight:bolder;
  }
  .el-tree-node__expand-icon.is-leaf + .el-tree-node__label{
    font-weight: normal;
  }
  video::-internal-media-controls-download-button {
    display:none;
  }

  video::-webkit-media-controls-enclosure {
    overflow:hidden;
  }
  video::-webkit-media-controls-panel {
    width: calc(100% + 30px);
  }
.el-checkbox__input{
  vertical-align: top;
}
.diaFoot{
  margin-top: 10px;
  text-align: right;
}

.hidden{
    opacity: 0;
    position: absolute;
    height: 38px;
    width: 120px;
}

.no-header-dialog .el-dialog__header {
  display: none;
  height:0px;
}

.no-title .el-dialog__title {
  display: none;
}

.editor2 {
    .ql-container {
        height: 220px !important;
    }
}

.aside .el-collapse-transition { transition:none !important; }
</style>
